























import { defineComponent, ref } from "@vue/composition-api";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import PrivateInvitationConfirm from "../PrivateInvitationConfirm";

export default defineComponent({
  name: "PrivateInvitationController",
  components: { PrivateInvitationConfirm, BaseIcon, BaseButton },
  props: {
    privateLivePrice: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const showConfirm = ref(false);

    const handlePrivateClick = useAuthorisedOnly(() => {
      showConfirm.value = true;
    });

    const handleCreateInvitation = (cb: () => void) => {
      emit("createInvitation", () => {
        cb();
        showConfirm.value = false;
      });
    };

    return { showConfirm, handlePrivateClick, handleCreateInvitation };
  },
});
